import AsyncStorage from '@react-native-async-storage/async-storage';

/**
 * Voix du recruteur ACTIVÉE PAR DÉFAUT (10/10/2026). Seul un choix volontaire de la couper est
 * mémorisé ; une valeur absente, jamais modifiée ou illisible vaut « activée ».
 */
const CLE = 'hormeia.voixRecruteur';

export async function lirePreferenceVoix(): Promise<boolean> {
  try {
    return (await AsyncStorage.getItem(CLE)) !== 'coupee';
  } catch {
    return true;
  }
}

export async function enregistrerPreferenceVoix(active: boolean): Promise<void> {
  try {
    await AsyncStorage.setItem(CLE, active ? 'activee' : 'coupee');
  } catch {
    // Préférence de confort : la perdre ne doit rien interrompre.
  }
}
